module.exports = __webpack_public_path__ + "static/4p-2-4284ce494eca253ceda6b3dafd2463a6.jpeg";